<template>
    <div class="Reports">
        <!--<b-button @click="TrainingReport()">Training Report</b-button>-->
        <b-row style="margin-left:1rem;">
            <b-card header-tag="header"
                    footer-tag="footer"
                    title="Training Report">
                <b-card-text>
                    <b-form @submit="TrainingReport">
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <span>Start Date:</span>
                                <flat-pickr class="form-control" v-model="StartDate" :config="DateConfig" required></flat-pickr>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <span>End Date:</span>
                                <flat-pickr class="form-control" v-model="EndDate" :config="DateConfig" required></flat-pickr>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <span>Region:</span>
                                <select class="form-control" v-model="Region">
                                    <option value="">All</option>
                                    <option v-for="region in UserPrivateProfile.Region" v-if="region != null" v-bind:value="region">{{ region }}</option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <span>Sub Program:</span>
                                <select class="form-control" v-model="SubProgramID">
                                    <option value="">All</option>
                                    <option v-for="subProgram in UserPrivateProfile.AssignedSubPrograms" v-bind:value="subProgram.Id">{{ subProgram.Name }}</option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <b-button block variant="success" type="submit"><font-awesome-icon :icon="['fa', 'download']" /> Download Report</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card-text>
            </b-card>
        </b-row>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faDownload } from '@fortawesome/free-solid-svg-icons';
    library.add(faDownload);
    import { EventBus } from '../../services/event-bus.js';
    export default {
        data: function () {
            return {
                StartDate: "",
                EndDate: "",
                Region: "",
                SubProgramID: "",
                DateConfig: {
                    dateFormat: 'Y-m-d G:i K',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y G:i K',
                    required: true,
                    enableTime: false
                },
            };
        },
        methods: {
            TrainingReport(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("GET", "Training/GetEmployeesInTraining",  {
                        StartDate: this.StartDate,
                        EndDate: this.EndDate,
                        Region: this.Region,
                        SubProgramID: this.SubProgramID,
                        ApplicationUserID: this.UserPrivateProfile.UserId
                    }, this.TrainingReportSuccess, () => { }, true);
            },
            TrainingReportSuccess(response) {
                let a = document.createElement("a") 
                let blobURL = URL.createObjectURL(response.data)
                a.download = response.headers["content-disposition"].split('=')[1];
                a.href = blobURL
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            flatPickr
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            }
        },
        mounted() {
        }
    }
    
</script>

<style scoped>
</style>